import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useBindingDriftReports} from '../hooks/useBindingDriftReports.ts';

export const ReloadRecordsButton = () => {

    const {reload} = useBindingDriftReports();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};
